import { makeStyles } from "@material-ui/core";
import { theme } from "theme";

export const useStyles = makeStyles((muiTheme) => ({
  title: {
    fontSize: "16px",
    color: theme.colors.light900,
  },
  gasolineIcon: {
    fill: theme.colors.light900,
    marginRight: "8px",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
  },
}));
